<template>
  <v-container class="container1" v-if="kitchen" :class="getThemeColor">
    <v-row class="d-flex align-center justify-center" style="overflow:hidden;" >
      <div class="d-flex align-center justify-center">
          <img
            :src="ip+kitchen.logo.url"
            data-aos="showupeffect" data-aos-duration="2000"
            alt="John"
            class="kitchenlogo"
          >
        <div class="kitchen-name-container" :class="getThemeColor">
          <div style="position:relative;overflow: hidden;">
            <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
            <div class="recipestitle customizefont1 font-size-XXL" style="opacity: 0;cursor:default">{{kitchen.name[$i18n.locale]}}</div>
            <div class="recipestitle customizefont1 font-size-XXL" data-aos-easing="ease-out" data-aos="custom-title-fade-in" data-aos-duration="2000" data-aos-delay="1000">{{kitchen.name[$i18n.locale]}}</div>
            <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
          </div>
        </div>
      </div>
    </v-row>
    <v-row v-if="!$vuetify.breakpoint.xs" id="kitchen-carousel" style="width:80%;margin:auto;padding-top:53.78%;position:relative;margin-top:30px;">
      <VueSlickCarousel v-bind="cc" style="position:absolute;top:0;height: 100%;left:0;width:100%;">
        <div
          v-for="photo in kitchen.slider"
          :key="photo.id"
        >
          <v-img
            height="100%"
            :src="ip+photo.url"
          />
        </div>
      </VueSlickCarousel>
    </v-row>
    <div v-if="$vuetify.breakpoint.xs" id="kitchen-carousel" style="width:100%;">
      <VueSlickCarousel v-bind="cc" style="width:100%;">
        <div
          v-for="photo in kitchen.slider"
          :key="photo.id"
        >
          <v-img
            height="100%"
            :src="ip+photo.url"
          />
        </div>
      </VueSlickCarousel>
    </div>
    <v-row class="session-spacing">
      <div style="position:relative;overflow: hidden;margin:auto;">
        <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
        <div :class="$i18n.locale=='en'?'georgia':'NotoSerifTC'" class="recipestitle2 font-size-XXL" style="opacity: 0;cursor:default">{{$t('kitchen_page.video_title')}}</div>
        <div :class="$i18n.locale=='en'?'georgia':'NotoSerifTC'" class="recipestitle2 font-size-XXL" data-aos-easing="ease-out" data-aos="custom-title-fade-in" data-aos-duration="2000">{{$t('kitchen_page.video_title')}}</div>
        <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
      </div>
      <!-- <span class="recipestitle2 customizefont1" data-aos="showupeffect" data-aos-duration="2000">VIDEO</span> -->
    </v-row>
    <v-row v-if="!$vuetify.breakpoint.xs" style="margin-top:30px;">
      <v-col class="videoblog" lg="3" md="3" sm="6" v-for="(video,i) in kitchen.Videos.slice((videoPage-1)*12, videoPage * 12)" :key="video.id" @click="openDialog(video,i,'video')" data-aos="fade-up" data-aos-duration="3000">
        <div class="video-card">
          <v-img
            :src="ip+video.thumbnail.url"
            alt="John"
            height="73.2%"
            width="100%"
            class="video-card-image"
          >
            <span class="video-card-time">
              {{video.video_duration}}
            </span>
          </v-img>
          <div class="video-card-desc font-size-s6">
            <!-- <span class="dincond">PM Kitchen</span> <span class="MHeiHK">第一集: <br>蜜汁松露叉燒</span> -->
            <span class="dincond">{{video.name_row1[$i18n.locale]}}</span><br>
            <span class="dincond">{{video.name_row2[$i18n.locale]}}</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <div v-if="$vuetify.breakpoint.xs">
      <div v-for="(video,i) in kitchen.Videos.slice((videoPage-1)*12, videoPage * 12)" :key="video.id" @click="openDialog(video,i,'video')" data-aos="fade-up" data-aos-duration="3000" 
          style="margin-top:15px;width:100%;padding-top:30%;background:#18432B;overflow:hidden;" >
        <v-row no-gutters style="position:absolute;top:0;left:0;right:0;bottom:0;height:100%;justify-content: center;padding-bottom:3px;">
          <v-col style="width:50%;height:100%;align-items: center;justify-content: center;display: flex;">
            <v-img
              :src="ip+video.thumbnail.url"
              max-width="100%"
              style="position:relative;"
            >
              <span class="video-card-time">
                {{video.video_duration}}
              </span>
            </v-img>
          </v-col>
          <v-col style="justify-content: start;align-items: flex-end;display: flex; padding-right: 20px;width:50%;margin-left:6px;border-bottom:1px mediumseagreen solid;border-right:1px mediumseagreen solid;margin-right: 2px;">
            <div style="height:100%;width:100%;position:relative;">
              <div style="position:absolute;bottom:0;left:5px;">
                <span class="dincond text-start" style="font-size:14px;color:white;">{{video.name_row1[$i18n.locale]}}</span><br>
                <span class="dincond text-start" style="font-size:14px;color:white;">{{video.name_row2[$i18n.locale]}}</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-row>
      <div style="margin: auto; margin-top:50px" data-aos="fade-up" data-aos-duration="3000">
        <span class="pageination" style="font-szie:15px" v-for="(w) in Math.ceil(kitchen.Videos.length/12)" :key=w :class="w==videoPage?'selected':null" v-on:click="videoPage=w;">{{w}}</span>
      </div>
    </v-row>
    <v-row class="session-spacing">
      <div style="position:relative;overflow: hidden;margin:auto;">
        <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
        <div :class="$i18n.locale=='en'?'georgia':'NotoSerifTC'" class="recipestitle2 font-size-XXL" style="opacity: 0;cursor:default">{{$t('kitchen_page.recipe_title')}}</div>
        <div :class="$i18n.locale=='en'?'georgia':'NotoSerifTC'" class="recipestitle2 font-size-XXL" data-aos-easing="ease-out" data-aos="custom-title-fade-in" data-aos-duration="2000">{{$t('kitchen_page.recipe_title')}}</div>
        <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
      </div>
    </v-row>
    <v-row v-if="!$vuetify.breakpoint.xs" >
      <v-col class="recipesblog" lg="3" md="3" sm="6" v-for="(recipe, i) in kitchen.Recipes.slice((recipePage-1)*12, recipePage*12)" :key="recipe.id" @click="openDialog(recipe,i,'recipe')" data-aos="fade-up" data-aos-duration="3000">
        <div class="video-card">
          <v-img
            :src="ip+recipe.thumbnail.url"
            alt="John"
            height="73.2%"
            width="100%"
            class="video-card-image"
          >
            <span class="video-card-time">
              {{recipe.video_duration}}
            </span>
          </v-img>
          <div class="video-card-desc font-size-s6">
            <span class="dincond">{{recipe.name_row1[$i18n.locale]}}</span><br>
            <span class="dincond">{{recipe.name_row2[$i18n.locale]}}</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <div v-if="$vuetify.breakpoint.xs">
      <div v-for="(recipe, i) in kitchen.Recipes.slice((recipePage-1)*12, recipePage*12)" :key="recipe.id" @click="openDialog(recipe,i,'recipe')" data-aos="fade-up" data-aos-duration="3000" 
          style="margin-top:15px;width:100%;padding-top:30%;background:#18432B;overflow:hidden;" >
        <v-row no-gutters style="position:absolute;top:0;left:0;right:0;bottom:0;height:100%;justify-content: center;padding-bottom:3px;">
          <v-col style="width:50%;height:100%;align-items: center;justify-content: center;display: flex;">
            <v-img
              :src="ip+recipe.thumbnail.url"
              max-width="100%"
            />
          </v-col>
          <v-col style="justify-content: start;align-items: flex-end;display: flex; padding-right: 20px;width:50%;margin-left:6px;border-bottom:1px mediumseagreen solid;border-right:1px mediumseagreen solid;margin-right: 2px;">
            <div style="height:100%;width:100%;position:relative;">
              <div style="position:absolute;bottom:0;left:5px;">
                <span class="dincond" style="float:left;width:100%;text-align:start;font-size:14px;color:white;">{{recipe.name_row1[$i18n.locale]}}</span><br>
                <span class="dincond" style="float:left;width:100%;text-align:start;font-size:14px;color:white;">{{recipe.name_row2[$i18n.locale]}}</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-row style="margin-top:50px;" data-aos="fade-up" data-aos-duration="3000">
      <div style="margin: auto; margin-top:50px">
        <span class="pageination" v-for="(w) in Math.ceil(kitchen.Recipes.length/12)" :key=w :class="w==recipePage?'selected':null" @click="recipePage=w;">{{w}}</span>
      </div>
    </v-row>
    <div class="custom-dialog" :class="dialog?'custom-dialog-show':''" v-if="currentRecipe&&dialog&&type=='video'">
      <div class="overlay" @click.self.stop="dialog = false;currentRecipe=null">
        <div class="main-dialog" :class="dialog?'ddd':''">
          <div style="position:absolute;top:0;bottom:0;left:0;right:0;background:white;opacity:0.9;"></div>
            <v-row class="ma-0 pa-3">
              <v-icon @click="dialog = false" style="cursor:pointer;color:black;margin-left: auto;" size=36>mdi-close</v-icon>
            </v-row>
            <v-row class="pa-4 inner-dialog">
              <div style="z-index:0;width:100%;padding-top:56.25%;position:relative;max-height:600px;" class="d-flex">
                <iframe style="position: absolute;top:0;bottom:0;left:0;right:0;" height="100%" width="100%" :src="'https://www.youtube.com/embed/'+currentRecipe.video_code" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <div style="z-index:0; font-size:16px; padding-top:10px;color:#132b1b;">
                {{currentRecipe.name_row1[$i18n.locale]}}
              </div>
            </v-row>
            <v-row class="pa-4">
              <div class="overlay-button d-inline-flex align-center" style="float:left;" v-on:click="toPrevious()">
                <simple-line-icons
                  icon="arrow-left"
                  size="small"
                  color="#132b1b"
                  style="float:left;"
                  no-svg
                />
                <span style="padding-left:10px" v-html="$t('kitchen_page.prev_video')"></span>
              </div>
            <div class="overlay-button d-inline-flex align-center " style="margin-left:auto;" v-on:click="toNext()">
              <span style="padding-right:10px;" v-html="$t('kitchen_page.next_video')"></span>
              <simple-line-icons
                icon="arrow-right"
                size="small"
                color="#132b1b"
                style="float:left;"
                no-svg
              />
            </div>
            </v-row>
        </div>
      </div>
    </div>
    <div class="custom-dialog" :class="dialog?'custom-dialog-show':''" v-if="currentRecipe&&dialog&&type=='recipe'">
      <div class="overlay" @click.self.stop="dialog = false;photoIndex=0;" >
        <div class="main-dialog" :class="dialog?'ddd':''">
          <div style="position:absolute;top:0;bottom:0;left:0;right:0;background:white;opacity:0.9;"></div>
            <v-row class="ma-0 pa-3">
              <v-icon @click="dialog = false;photoIndex=0;" style="cursor:pointer;color:black;margin-left: auto;" size=36>mdi-close</v-icon>
            </v-row>
            <v-row class="pa-0 inner-dialog">
              <v-col v-if="!$vuetify.breakpoint.xs" sm=1 md=1 lg=1 xl=1 class="d-flex justify-center align-center" style="z-index:0;cursor:pointer;" v-on:click="photoIndex==0?photoIndex=currentRecipe.contents.length-1:photoIndex--;">
                  <simple-line-icons
                    icon="arrow-left"
                    class="align-self-center"
                    color="black"
                    style="font-size:60px;"
                    no-svg
                  />
              </v-col>
              <v-col sm=10 md=10 lg=10 xl=10 style="z-index:0;" class="pa-1">
                <div class="text-left overlay-title">
                  {{currentRecipe.name_row1[$i18n.locale]}} <span style="color:mediumseagreen;"> {{currentRecipe.event_date}}</span>
                </div>
                <v-img
                  :src="ip+currentRecipe.contents[photoIndex].url"
                  contain
                />
              </v-col>
              <v-col v-if="!$vuetify.breakpoint.xs" sm=1 md=1 lg=1 xl=1 class="d-flex justify-center align-center" style="z-index:0;cursor:pointer;" v-on:click="photoIndex==currentRecipe.contents.length-1?photoIndex=0:photoIndex++;">
                <simple-line-icons
                  icon="arrow-right"
                  color="black"
                  style="font-size:60px;"
                  no-svg
                />
              </v-col>
              <v-col v-if="!$vuetify.breakpoint.xs || currentRecipe.contents.length>1" sm=10 md=10 lg=10 xl=10 class="d-flex justify-center align-center" style="margin:auto;margin-top:0;padding-top:0;">
                <v-row class="d-flex" style="margin-top:0;padding-top:0; padding-bottom:60px">
                  <v-col sm=2 md=2 lg=2 xl=2 class="pa-1" style="cursor:pointer;" v-for="(p, i) in currentRecipe.contents" :key="p.id" >
                    <v-img
                      :src="ip+p.formats.thumbnail.url"
                      alt="John"
                      v-on:click="photoIndex=i"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script> 
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import axios from 'axios';
var ip = "https://lorencegroup.com/api";
export default {
  name: 'Kitchen',
  components: {
    VueSlickCarousel
  },
  data: () => ({
    "cc": {
      "arrows": false,
      "dots": true,
      "fade": true,
      "infinite": true,
      "slidesToShow": 1,
      "slidesToScroll": 1,
      "autoplay": true,
      "autoplaySpeed": 4000,
      "speed": 1000,
      "pauseOnDotsHover": true,
      "pauseOnFocus": true,
      "pauseOnHover": true,
    },
    dialog: false,
    kitchen: null,
    currentRecipe: null,
    type: null,//recipe or video
    currentIndex: 0,
    photoIndex: 0,
    ip: ip,
    videoPage: 1,
    recipePage: 1
  }),
  mounted () {
    axios.get(ip+"/kitchens/"+this.$router.history.current.params.kitchen_id)
    .then(response => {
      this.kitchen=response.data;
      this.kitchen.name=[]
      this.kitchen.name["en"] = this.kitchen.display_name_english;
      this.kitchen.name["zh_TW"] = this.kitchen.display_name_trad_chinese;
      this.kitchen.Videos.forEach(video => {
        video.name_row1 = []
        video.name_row2 = []
        video.name_row1["en"] = video.display_name_row1_english
        video.name_row2["en"] = video.display_name_row2_english
        video.name_row1["zh_TW"] = video.display_name_row1_trad_chinese
        video.name_row2["zh_TW"] = video.display_name_row2_trad_chinese
      });
      this.kitchen.Recipes.forEach(recipe => {
        recipe.name_row1 = []
        recipe.name_row2 = []
        recipe.name_row1["en"] = recipe.display_name_row1_english
        recipe.name_row2["en"] = recipe.display_name_row2_english
        recipe.name_row1["zh_TW"] = recipe.display_name_row1_trad_chinese
        recipe.name_row2["zh_TW"] = recipe.display_name_row2_trad_chinese
      });
    })
    .catch(e => {
      console.log(e)
      //this.errors.push(e)
    })
  },
  methods: {
    openDialog: function(obj, i ,type){
      this.currentIndex = i;
      this.currentRecipe = obj;
      this.type = type;
      this.dialog = true;
    },
    toNext: function(){
      if(this.currentIndex==this.kitchen.Videos.length-1){
        this.currentIndex=0;
      }else{
        this.currentIndex++;
      }
      if(this.type == 'video'){
        this.currentRecipe=this.kitchen.Videos[this.currentIndex]
      }else{
        this.currentRecipe=this.kitchen.Recipes[this.currentIndex]
      }
    },
    toPrevious: function(){
      if(this.currentIndex==0){
          this.currentIndex=this.kitchen.Videos.length-1;
        }else{
          this.currentIndex--;
        }
      if(this.type == 'video'){
        this.currentRecipe=this.kitchen.Videos[this.currentIndex]
      }else{
        this.currentRecipe=this.kitchen.Recipes[this.currentIndex]
      }
    },
  },
  computed: {
    getThemeColor: function(){
      return {
        'black-theme': this.kitchen.theme=='black',
        'green-theme': this.kitchen.theme=='green'
      }
    },
  }
}
</script>
<style scoped>
.container1{
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 3%;
  padding-bottom: 2%;
}

.mobile .container1{
  padding-left: 0;
  padding-right: 0;
  padding-top: 3%;
  padding-bottom: 2%;
}

.overlay-button{
  z-index: 0;
  background: white;
  font-size:14px;
  margin-top: 13px;
  padding: 5px 20px;
  color: #132b1b;
  border: #132b1b solid 1px;
  display: flex;
  width: fit-content;
  align-items:center;
  cursor: pointer;
}

.overlay-button:hover{
  background: mediumseagreen;
}

.custom-dialog{
  overflow-y: scroll;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}
.custom-dialog-show{
  z-index: 1;
}
.custom-dialog .overlay{
  height: 100%;
  width: 100%;
}
.custom-dialog .main-dialog{
  position: relative;
  margin: auto;
}
.custom-dialog .main-dialog span{
  color: #132b1b;
}

.custom-dialog .main-dialog .special-text{
  color: mediumseagreen;
  z-index: 0;
}
.session-spacing{
  margin-top: 80px;
}
.mobile .session-spacing{
  margin: 24px;
}
@media (min-width: 768px) { 
  .custom-dialog .main-dialog{
    width: 100%;
  }


  .inner-dialog{
    margin: auto;
  }
}
@media (min-width: 992px) { 
  .custom-dialog .main-dialog{
    width: 100%;
  }

  .our-recipes-fontsize{
    font-size: 8px;
  }


  .inner-dialog{
    margin: auto;
  }
}
@media (min-width: 1264px) {
  .custom-dialog .main-dialog{
    width: 100%;
  }

  .our-recipes-fontsize{
    font-size: 14px;
  }

  .inner-dialog{
    margin: auto;
  }
}
@media (min-width: 1904px) { 
  .custom-dialog .main-dialog{
    width: 100%;
  }

  .our-recipes-fontsize{
    font-size: 16px;
  }

  .inner-dialog{
    margin: auto;
  }
}
.kitchen-name-container{
  font-family: 'dincond';
  float:left;
  display:flex;
  align-items:center;
  height:120px;
}
.recipestitle{ 
  padding: 15px;
}
.mobile .recipestitle{
  padding: 8px 3px;
  letter-spacing: 3px;
}
.kitchenlogo{
  height:130px; 
  margin-right:20px;
}
.mobile .kitchenlogo{
  margin: 10px;
}
.kitchen-photo{
  width: 70%;
  margin: auto;
}
.recipestitle2{
  text-transform: uppercase;
  letter-spacing: 5px;
  margin:auto;
  padding: 10px 26px;
  margin-top:7px;
  margin-bottom:7px;
  color: white;
}
.mobile .recipestitle2{
  text-transform: uppercase;
  letter-spacing: 4px;
  margin:auto;
  padding: 3px 16px;
  margin-top:7px;
  margin-bottom:7px;
  color: white;
}
.videoblog{
  margin-top:20px;
}

.recipesblog{
  margin-top:20px;
}
.video-card{
  cursor: pointer;
  position: relative;
  padding-top:80.3%;
}

.video-card-image{
  position: absolute;
  top:0;
  left:0;
}
.video-card-desc{
  font-family: 'dincond';
  letter-spacing: 2px;
  position: absolute;
  padding: 1px;
  padding-left: 10px;
  text-align: left;
  top:77.2%;
  left:0;
  height: 25%;
  width: 100%;
  color: white;
  border-left: 1px solid green;
  border-bottom: 1px solid green;
}
.video-card-image:hover + .video-card-desc{
  color: green;
}
.video-card div:hover + .video-card-desc{
  color: green;
}
.video-card-desc:hover{
  color: green;
}
.video-card-time{
  background: black;
  color: white;
  opacity: .7;
  position: absolute;
  top: 86%;
  left: 88%;
}
.mobile .video-card-time{
  background: black;
  color: white;
  opacity: .7;
  position: absolute;
  top: 5%;
  left: 5%;
}
.pageination{
  color: white;
  margin: 10px;
  cursor: pointer;
}
.selected{
  text-decoration: underline;
}
.customizefont1{
  font-family: Georgia, 'Times New Roman', Times, serif;
  letter-spacing: 5px;
  color: white;
}

.MHeiHK{
  font-family: 'MHeiHK';
}

.slide-container{
  padding-top: 66.4%;
  position: relative;
}
</style>